/**
 * DOĞRUDAN PDF İNDİRME — window.print() diyaloğunun yerine geçer.
 * Ekrandaki rapor kökü (seçiciyle) stilleriyle birlikte serileştirilir,
 * /api/pdf sunucuda headless Chromium ile gerçek PDF basar, dosya iner.
 * Sunucu PDF üretemezse (Chromium yok vb.) eski davranışa düşer: window.print().
 *
 * Notlar:
 * - Ekranlardaki mevcut @media print kuralları PDF'te de aynen işler
 *   (Chromium PDF'i print-media ile basar) — gizlenen butonlar gizli kalır.
 * - Koyu tema PDF'e taşınmaz: gövde "dark" sınıfı olmadan serileştirilir,
 *   rapor her zaman beyaz zeminli/koyu metinli çıkar.
 */
export async function pdfIndir(kokSecici: string, dosyaAdi: string): Promise<void> {
  const kok = document.querySelector(kokSecici);
  if (!kok) { window.print(); return; }

  try {
    // Sayfadaki tüm stilleri topla: <style> aynen, <link rel=stylesheet> içeriği çekilip inline edilir
    // (PDF sayfası güvenlik gereği dış istek yapamaz — her şey gömülü gitmeli).
    const stiller = await Promise.all(
      [...document.querySelectorAll('style, link[rel="stylesheet"]')].map(async (el) => {
        if (el.tagName === "STYLE") return el.outerHTML;
        try {
          const css = await (await fetch((el as HTMLLinkElement).href)).text();
          return `<style>${css}</style>`;
        } catch { return ""; }
      }),
    );

    const gövdeSinifi = document.body.className.replace(/\bdark\b/g, "").trim();
    const html = [
      '<!doctype html><html><head><meta charset="utf-8">',
      ...stiller,
      // PDF'e özel emniyet: beyaz zemin, kaydırma kapalı, kök tam genişlik
      "<style>html,body{background:#fff !important;overflow:visible !important} body{margin:0;padding:16px}</style>",
      "</head>",
      `<body class="${gövdeSinifi}">`,
      kok.outerHTML,
      "</body></html>",
    ].join("");

    const r = await fetch("/api/pdf", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ html, baslik: dosyaAdi }),
    });
    if (!r.ok) { window.print(); return; }

    const blob = await r.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `${dosyaAdi}.pdf`;
    a.click();
    URL.revokeObjectURL(a.href);
  } catch {
    window.print(); // ağ hatasında da kullanıcı çıktısız kalmasın
  }
}
